import { stableHash } from './hash';

export const compare = function(currentData, newData) {
    return stableHash(currentData) === stableHash(newData);
};
